const getters = {
    is_collapse: state => state.app.is_collapse,
    leftMenuShowState: state => state.app.leftMenuShowState,
    domain: state => state.app.domain,
    mainDomain: state => state.app.mainDomain,
    aliyunPath: state => state.app.aliyunPath,
    defalutImgPath: state => state.app.defalutImgPath,
    size: state => state.app.size,
    projects: state => state.menu.projects,
    apps: state => state.menu.apps,
    menus: state => state.menu.menus,
    routes: state => state.menu.routes,
    appMenus: state => state.menu.appMenus,
    selectedApp: state => state.menu.selectedApp,
    selectedMenuId: state => state.menu.selectedMenuId,
    currentPath: state => state.menu.currentPath,
    openedSubmenuArr: state => state.menu.openedSubmenuArr,
    token: state => state.user.token,
    name: state => state.user.name,
    userId: state => state.user.userId,
    userName: state => state.user.userName,
    userHeadImg: state => state.user.userHeadImg,
    schoolId: state => state.user.schoolId,
    schoolName: state => state.user.schoolName,
    adminType: state => state.user.adminType,
    userType: state => state.user.userType,
    subjectId: state => state.user.subjectId,
    subjectName: state => state.user.subjectName,
    roleIds: state => state.user.roleIds,
    schoolFrom: state => state.user.schoolFrom,
    phase: state => state.user.phase,
    origin: state => state.user.origin,
    regionAdminInfo: state => state.user.regionAdminInfo,
    weakPassword: state => state.user.weakPassword,
    dictProductType: state => state.dict.dictProductType,
    dictAppType: state => state.dict.dictAppType,
    dictAppLabel: state => state.dict.dictAppLabel,
    dictAppCatalog: state => state.dict.dictAppCatalog,
    dictScene: state => state.dict.dictScene,
    baseDictCountry: state => state.dict.baseDictCountry,
    baseDictCategory: state => state.dict.baseDictCategory,
    baseDictSchoolType: state => state.dict.baseDictSchoolType,
    runtimeEnvir: state => state.app.runtimeEnvir,
    logoPathPre: state => state.app.logoPathPre,
    isCodeLogin: state => state.user.isCodeLogin,
    mobile: state => state.user.mobile,
    classAdmin: state => state.user.classAdmin,
    appType: state => state.app.appType,
};

export default getters;